import { useSelector } from 'react-redux';
import { ProductCode, BillingPlanCategory } from '@dev/ee-api/ee-api-models';
import { find } from 'lodash-es';

import { getGeneralInfo } from '@api/store/account/actions';
import { getBillingPlanList } from '@api/store/products/actions';
import { useCurrentPlanStatus } from '../useCurrentPlanStatus';

type BillingPlanParams = {
    billingPlanID: number;
    defaultTierID: number;
    canSeeChangeProduct: boolean;
};

export const useAvailableSwitchProduct = (): BillingPlanParams => {
    const { IsSub, IsPro } = useSelector(getGeneralInfo);
    const { isExpired, isTrialOrFree, isFree } = useCurrentPlanStatus();

    let planCategory = IsPro ? [BillingPlanCategory.Pro] : [BillingPlanCategory.Standard];

    if (isFree) {
        planCategory = [BillingPlanCategory.Free,BillingPlanCategory.Pilot];
    }

    const billingPlans = useSelector(getBillingPlanList);
    const plan = find(billingPlans, (plan) => plan.ProductCode === ProductCode.Marketing && planCategory?.includes?.(plan.Category));

    const billingPlanID = plan?.BillingPlanID;
    const defaultTierID = find(plan?.Tiers, (item) => item.Tier === plan.DefaultTier)?.BillingPlanTierID;

    const canSeeChangeProduct = !IsSub && isTrialOrFree && !isExpired;

    return { billingPlanID, defaultTierID, canSeeChangeProduct };
};
